/**
 * @remarks \@since 2.5.0
 */
export var DEFAULT_SLIDER_GET_VALUE_TEXT = function () { return ""; };
/**
 * @remarks \@since 2.5.0
 */
export var DEFAULT_SLIDER_MIN = 0;
/**
 * @remarks \@since 2.5.0
 */
export var DEFAULT_SLIDER_MAX = 100;
/**
 * @remarks \@since 2.5.0
 */
export var DEFAULT_SLIDER_STEP = 1;
/**
 * @remarks \@since 2.5.0
 */
export var DEFAULT_SLIDER_ANIMATION_TIME = 150;
/**
 * @remarks \@since 2.5.0
 */
export var THUMB_1_VAR = "--offset1";
/**
 * @remarks \@since 2.5.0
 */
export var THUMB_2_VAR = "--offset2";
//# sourceMappingURL=constants.js.map